module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Settlement"
  }, [_c('div', {
    staticClass: "Settlementcont"
  }, [_c('div', {
    staticClass: "feiyong"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "sum"
  }, [_c('span', {
    staticClass: "daxie"
  }, [_vm._v(_vm._s(_vm.DJOrderFee && _vm.DJOrderFee.real_pay ? _vm.DJOrderFee.real_pay.toFixed(1) : 0))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detailed"
  }, [_c('span', {
    on: {
      "click": _vm.detailsBoxFn
    }
  }, [_vm._v("费用详情"), _c('i', {
    staticClass: "iconfont icon-iconfontyiwen"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "payType"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "payTypeContent"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.payTypeFn(1)
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icon-yue Icon"
  }), _vm._v("\n              余额支付\n              "), _c('span', {
    staticClass: "select",
    class: _vm.data.payType == 1 ? 'selectAction' : ''
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])])]), _vm._v(" "), (_vm.wxState) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.payTypeFn(2)
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icon-weixin Icon"
  }), _vm._v("\n          微信支付\n          "), _c('span', {
    staticClass: "select",
    class: _vm.data.payType == 2 ? 'selectAction' : ''
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.loginData.passenger && _vm.loginData.passenger.allowOverdraw) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.payTypeFn(3)
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icon-qiandan-copy Icon"
  }), _vm._v("\n              签单支付\n              "), _c('span', {
    staticClass: "select",
    class: _vm.data.payType == 3 ? 'selectAction' : ''
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "submitBut",
    on: {
      "click": _vm.payFn
    }
  }, [_c('span', [_vm._v("立即支付")])])]), _vm._v(" "), _c('Xk-detailsBox', {
    ref: "detailsBox",
    staticClass: "costBox",
    attrs: {
      "title": '费用详情'
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', _vm._l((_vm.orderFeeDetail), function(item) {
    return _c('li', {
      staticClass: "clear"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "val"
    }, [_c('span', {
      staticClass: "sum"
    }, [_vm._v(_vm._s(item.cost))]), _c('span', {
      staticClass: "unit"
    }, [_vm._v("元")])])])
  }), 0)])]), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  }), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("支付费用")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("支付方式")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0163fe74","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/daijia/settlement.vue
// module id = 497
// module chunks = 0